import Cookies from 'js-cookie'

const user = {
	state: {

	},
	mutations: {
		logout (state,vm) {
        	Cookies.remove('access');
        	localStorage.removeItem("btoken");
            localStorage.removeItem("buserid");
            localStorage.removeItem("ctoken");
            localStorage.removeItem("cuserid");
		}
	}
}

export default user;


// WEBPACK FOOTER //
// ./src/store/modules/user.js